export default "__VITE_ASSET__d00e4d4b__"